function PathHelper($urlMatcherFactory, $location) {
    'ngInject';

    return {
        /***
         * @ngdoc method
         * @name matchRouteToPath
         * @methodOf BB:PathHelper
         * @description
         * Get the email pattern
         * @param {string} the route format
         * @param {string} optional argument specifying the param to return from the path if matched, e.g. 'page'
         *
         * @returns {Object} the match object or matched param
         */
        matchRouteToPath(route_format, param) {

            if (!$location.path() || !route_format) {
                return false;
            }

            const parts = route_format.split('/');
            let match = null;

            while ((parts.length > 0) && !match) {
                const match_test = parts.join('/');
                const pattern = $urlMatcherFactory.compile(match_test);
                match = pattern.exec($location.path());
                parts.pop();
            }

            if (match[param]) {
                return match[param];
            } else {
                return match;
            }
        }
    };
}

/***
 * @ngdoc service
 * @name BB:PathHelper
 *
 * @description
 * Helper service for retrieving params from $location.path
 *
 */
angular
    .module('BB')
    .service('PathHelper', PathHelper);




// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_services/path_helper.service.js